<span (click)="openDetailCandidate()"
      class="cursor-pointer text-action">
  Voir plus
</span>
